import React from 'react';
import clsx from 'clsx';

import {DialogProps} from '@material-ui/core/Dialog';
import {FormControlLabel, Checkbox, DialogContent, DialogActions} from '@material-ui/core';
import CustomDialog from '../CustomDialog';
import Instruction from '../Instruction';
import TextHelper from '../TextHelper';
import {CheckIcon} from '../Icon';
import Button from '../Button';

import {useTranslation} from 'react-i18next';

import {COD_INSTRUCTION} from '../../constants/render';
import codConfirmImage from '../../assets/image/payment-manabie-confirm.png';

import styles from './DialogCod.module.css';

interface DialogCodProps extends DialogProps {
  tickStatus: boolean
  isLoading: boolean
  errStatus: boolean

  onClose: () => void
  onConfirm: () => void
  onTickChanged: (e: any) => void
}


const DialogCod = (props: DialogCodProps) => {
  const {t} = useTranslation();

  const {
    tickStatus,
    isLoading,
    errStatus,
    onClose,
    onConfirm,
    onTickChanged,
    ...rest
  } = props;

  return (
    <CustomDialog {...rest}>
      <DialogContent className={styles.dialogContentRoot}>
        <div>
          <div className={styles.confirmBanner}>
            <div className={styles.confirmImage}>
              <img
                src={codConfirmImage}
                alt="manabie confirm"
                width="100%"
              />
            </div>
            <div className={styles.confirmText}>
              <span className={styles.confirmBannerThankYou}>{t('thankYouForYourOrder')}</span>
              <div className={styles.confirmRead}>
                {t('pleaseReadThisBefore')}
              </div>
            </div>
          </div>
          <div className={styles.divider}/>
          <div className={styles.instruction}>
            <Instruction instructions={COD_INSTRUCTION} renderListStyle={() => {
              return <CheckIcon width={20} height={20}/>
            }}/>
            <div className={styles.policy}>
              <FormControlLabel
                className={styles.policyLabelControl}
                control={
                  <Checkbox
                    name="policy"
                    value={tickStatus}
                    onChange={props.onTickChanged}
                  />
                }
                label={
                  <div className={styles.read}>
                    <span>{t('iHave')}</span>
                    <strong>{t('readAndAgreed')}</strong>
                    <span>{t('uponAbove')}</span>
                  </div>
                }
              />
            </div>
            {
              errStatus &&
              <TextHelper className={styles.textHelper} type="alert">
                {t('pleaseTickOnCheckbox')}
              </TextHelper>
            }
          </div>
        </div>
      </DialogContent>
      <DialogActions
        className={styles.dialogAction}
        classes={{
          root: styles.dialogActionRoot,
          spacing: styles.dialogActionSpacing
        }}
      >
        <Button
          className={clsx(styles.button, styles.buttonCancel)}
          onClick={onClose}
          disabled={isLoading}
        >
          {t('close')}
        </Button>
        <Button
          className={clsx(styles.button, styles.buttonConfirm)}
          loading={isLoading}
          disabled={isLoading}
          onClick={onConfirm}
        >
          {t('confirm')}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default DialogCod;
